export const RRP_POPSTATION_LIMIT = 3;
